import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import IncomingRegModal from "../../../../modal/PC/purchase/IncomingRegModal";
import IncomingUpdateModal from "../../../../modal/PC/purchase/IncomingUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';

const Incoming = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        search:'',
        status:''
    });
    const [userTypeModalOption, setUserTypeModalOption] = useState([]);
    const [qualityYnModalOption, setQualityYnModalOption] = useState([]);
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectIncomingID, setSelectIncomingID] = useState('');
    const [statusOption, setStatusOption] = useState([]);
    const [paramID, setParamID] = useState('');
    const [initialEditOpenDone, setInitialEditOpenDone] = useState(true);
    
    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'updated',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            (MenuDeleteExistYN === "Y"?
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' && params.row.incoming_status === "D" ? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' && params.row.incoming_status === "D" ? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            { field: 'id', headerName: 'incoming_id', width: 0, headerAlign: 'center' },
            { field: 'incoming_number', headerName: '입고번호', width: 120, headerAlign: 'center', align:'center'},
            { field: 'incoming_status', headerName: 'incoming_status', width: 0, headerAlign: 'center'},
            { field: 'incoming_status_name', headerName: '입고상태', width: 100, headerAlign: 'center', align:'center'},
            { field: 'incoming_partner_name', headerName: '입고처', width: 250, headerAlign: 'center', align:'left'},
            { field: 'incoming_purchase_info', headerName: '발주정보', width: 250, headerAlign: 'center', align:'left'},
            { field: 'incoming_partner_manager', headerName: '담당자', width: 120, headerAlign: 'center', align:'center'},
            { field: 'incoming_partner_manager_phone', headerName: '담당자 휴대폰', width: 160, headerAlign: 'center', align:'center' },
            { field: 'incoming_partner_manager_mail', headerName: '담당자 메일', width: 250, headerAlign: 'center', align:'left' },
            { field: 'incoming_use_cnt', headerName: 'incoming_use_cnt', width: 0, headerAlign: 'center'},
            { field: 'recent_update_user_name', headerName: '최근수정자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'recent_update_datetime', headerName: '최근수정일시', width: 180, headerAlign: 'center', align:'center' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        incoming_number: true,
        incoming_status: false,
        incoming_status_name: true,
        incoming_partner_name: true,
        incoming_purchase_info: true,
        incoming_partner_manager: true,
        incoming_partner_manager_phone: true,
        incoming_partner_manager_mail: true,
        incoming_use_cnt: false,
        deleted: true,
        updated: true,
        recent_update_user_name: true,
        recent_update_datetime: true,
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            
            if(params.incoming_id !== null && typeof params.incoming_id !== 'undefined'){
                setParamID(params.incoming_id);
            }
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.status])
    
    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    useEffect(() => {
        if (originRows.length > 0 && paramID && initialEditOpenDone) {
            const filtered = originRows.filter(row => String(row.incoming_id) === String(paramID));

            if (filtered.length > 0) {
                setSelectIncomingID(paramID);
                setUpdateModalOpen(true);
                setModalTitle('입고 수정');
                setInitialEditOpenDone(false);
            }
        }
    }, [originRows, paramID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        axios.get('/api/p/Incoming/List',
            {
            params : {
              search : keyword.search,
              status : keyword.status
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.incoming_id]) {
                    PermissionMap[row.incoming_id] = [row.reg_user_id, row.update_user_id, row.incoming_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });
            
            var array = response.data.map((item, index) => ({
                id: item.incoming_id,
                incoming_number: item.incoming_number,
                incoming_status: item.incoming_status,
                incoming_status_name: item.incoming_status_name,
                incoming_partner_name: item.incoming_partner_name,
                incoming_purchase_info: (((item.incoming_purchase_number === undefined || item.incoming_purchase_number === ''? '':'['+item.incoming_purchase_number+'] ')+(item.incoming_purchase_name === undefined || item.incoming_purchase_name === ''? '':item.incoming_purchase_name))).trim(),
                incoming_partner_manager: item.incoming_partner_manager,
                incoming_partner_manager_phone: item.incoming_partner_manager_phone,
                incoming_partner_manager_mail: item.incoming_partner_manager_mail,
                incoming_use_cnt: item.incoming_use_cnt,
                recent_update_user_name: (item.update_user_name === undefined || item.update_user_name === ''?item.reg_user_name:item.update_user_name),
                recent_update_datetime: (item.update_datetime === undefined?Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss'):Moment(item.update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_flag: PermissionMap[item.incoming_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    }

    const handleInitSelect = () => {

        //입고상태
        var array = [
            {value:'', label:'전체'}
            ,{value:'S', label:'입고완료'}
            ,{value:'D', label:'입고취소'}
        ];
        setStatusOption(array);
        
        // 검사여부, 담당자 유형
        axios.get('/api/Common/CodeDetailList')
        .then((response) => { 

            var user_type_array_modal = [];
            var quality_yn_array_modal = [];
            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0020'){
                    user_type_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }
            }

            var quality_yn_array_modal = [
                {value:'Y', label:'Y'}
                ,{value:'N', label:'N'}
            ];

            setQualityYnModalOption(quality_yn_array_modal);
            setUserTypeModalOption(user_type_array_modal);
        })
        .catch((error) => {
            console.log(error);
        });        
    }

    const handleInit = () => {
        setKeyword({
            search: '',
            status: ''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            incoming_number: true,
            incoming_status: false,
            incoming_status_name: true,
            incoming_purchase_info: true,
            incoming_partner_name: true,
            incoming_partner_manager: true,
            incoming_partner_manager_phone: true,
            incoming_partner_manager_mail: true,
            incoming_use_cnt: false,
            deleted: true,
            updated: true,
            recent_update_user_name: true,
            recent_update_datetime: true,
            update_flag: false
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('입고 등록');
    };
    
    const UpdateClick = (object) => {
        setUpdateModalOpen(true);
        setModalTitle('입고 수정');
        setSelectIncomingID(object.row.id);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '입고번호 '+object.row.incoming_number+' 삭제',
            html : '입고번호 '+object.row.incoming_number+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/Incoming/Delete', new URLSearchParams({
                    delete_incoming_id: object.row.id,
                    folder: 'Incoming'
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){

                        Swal.fire({
                            title: '입고번호 '+object.row.incoming_number+' 삭제 완료',
                            text: '정상적으로 입고번호 '+object.row.incoming_number+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .then(function () {
                    appStore.setLoading(false);
                });
            }
        });
    };

    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };
    
    const handleRegSuccessSave = (regID) => {
        setModalTitle('입고 수정');
        setRegModalOpen(false);
        handleView();

        Swal.fire({
            title: '입고 등록 완료',
            text: '정상적으로 입고가 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setUpdateModalOpen(true);
            setSelectIncomingID(Number(regID));
        });
    };

    const handleExcel = () => {
        var filename = '입고관리'
        axios.get('/api/p/Incoming/Excel',
        {   
            params : { search : keyword.search, status : keyword.status, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
        /*
        axios.get('/api/p/ExcelUpload/incoming',
        {   
            params : { file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
        */
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y'&& (
                        <IncomingRegModal
                        onClose={() => {
                            setRegModalOpen(false);
                        }}
                        title={modalTitle}
                        handleRegSuccessSave={handleRegSuccessSave}
                        userTypeModalOption={userTypeModalOption}
                        qualityYnModalOption={qualityYnModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            입고상태
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="입고상태" onChange={(e) => onSelectChange('status',e.value)} value={statusOption.filter(function (option) { return option.value === keyword.status;  })} options={statusOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="none" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && (
                        <IncomingUpdateModal
                        onClose={() => {
                            setUpdateModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectIncomingID}
                        originRows={originRows.filter(row => String(row.incoming_id) === String(selectIncomingID))}
                        handleView={handleView}
                        userTypeModalOption={userTypeModalOption}
                        qualityYnModalOption={qualityYnModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        MenuDeleteYN={MenuDeleteYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default Incoming;
